import React from "react";
import {Link} from "react-router-dom";
import Avatar from "../Avatar";

const defaultImg =
  "https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png";

const SenderCard = ({sender}) => {
  const fullImage =
    sender?.identifications?.find((x) =>
      x?.identification_category?.name?.toLowerCase()?.includes("full image")
    )?.resource_path ?? defaultImg;

  return (
    <div className="flex flex-col min-w-[180px] bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] p-5 gap-4 h-full w-full sm:w-auto items-start">
      <div className="flex items-center justify-between w-full">
        <div className="relative">
          <Avatar 
            src={fullImage}
            className="w-12 h-12"
            bgColor="bg-gradient-to-br from-purple-100 to-pink-100" 
            iconColor="text-purple-500"
          />
          <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
        </div>
      </div>

      <div className="flex flex-col gap-2 w-full">
        <Link to={`/sender/${sender?.id}`} className="text-gray-900 font-semibold text-base hover:text-blue-600 transition-colors">
          {sender?.firstname} {sender?.lastname}
        </Link>
        <p
          title={sender?.email}
          className="text-gray-500 truncate w-full font-normal text-sm"
        >
          {sender?.email}
        </p>
      </div>

      <Link
        to={`/sender/${sender?.id}`}
        className="w-full mt-auto bg-blue-50 hover:bg-blue-100 text-blue-600 font-medium py-2.5 px-4 rounded-lg text-center transition-colors duration-200 text-sm"
      >
        View Profile
      </Link>
    </div>
  );
};

export default SenderCard;
